export var TabTrayLayout;
(function (TabTrayLayout) {
    TabTrayLayout["Horizontal"] = "Horizontal";
    TabTrayLayout["Vertical"] = "Vertical";
})(TabTrayLayout || (TabTrayLayout = {}));
export var TabTraySize;
(function (TabTraySize) {
    TabTraySize["Small"] = "Small";
    TabTraySize["Medium"] = "Medium";
})(TabTraySize || (TabTraySize = {}));
export var TabHeaderHorizontalAlignment;
(function (TabHeaderHorizontalAlignment) {
    TabHeaderHorizontalAlignment["LEFT"] = "left";
    TabHeaderHorizontalAlignment["CENTER"] = "center";
    TabHeaderHorizontalAlignment["RIGHT"] = "right";
})(TabHeaderHorizontalAlignment || (TabHeaderHorizontalAlignment = {}));
//# sourceMappingURL=common.js.map